export default __webpack_public_path__ + "static/Psoriazal-Plus-home-@3x-6dc3fde1bed82da36dc12ddfc8061741.jpg";